import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function SolutionsPage() {
    const { t } = useTranslation(['home', 'common', 'pages']);

    useEffect(() => {
        document.title = t('pages:solutions');
    }, []);

    usePreventClickjacking();

    return (
        <div className="container2">
            <div className="contentPageContainer2">
                <div className="container-grande2">
                    <h4>{t('pages:solutions')}</h4>
                    <p>{t('home:solutionsPage.textSolution1')}</p>
                    <p>{t('home:solutionsPage.textSolution2')}</p>
                    <p>{t('home:solutionsPage.textSolution3')}</p>
                    <p>{t('home:solutionsPage.textSolution4')}</p>
                    <p>{t('home:solutionsPage.textSolution5')}</p>
                </div>
            </div>
        </div>
    );
}

export default SolutionsPage;
